import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SolutionSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-159">
      <div className="container mx-auto max-w-4xl" data-id="element-160">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-161">
          <div className="bg-gradient-to-br from-[#eab308]/10 to-[#d4a017]/5 border border-[#eab308]/20 rounded-2xl p-5 sm:p-8 md:p-10 text-center shadow-lg" data-id="element-162">
            <p className="text-xl sm:text-2xl md:text-3xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-163">
              La biodecodificación conecta los tres planos:
            </p>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-base sm:text-lg" data-id="element-164">
              <span className="text-[#f0c040] font-medium" data-id="element-165">el biológico</span>
              <span className="text-gray-500" data-id="element-166">·</span>
              <span className="text-[#f0c040] font-medium" data-id="element-167">el emocional</span>
              <span className="text-gray-500" data-id="element-168">·</span>
              <span className="text-[#f0c040] font-medium" data-id="element-169">el simbólico</span>
            </div>
            <p className="text-gray-300 text-lg mt-6" data-id="element-170">
              Y cuando los tres se alinean, algo profundo empieza a cambiar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}